import { withDefaultNavigation, withoutItemsNavigation } from '@eig-builder/module-navigation'
import ParentTabsRouteWrapper from '@eig-builder/module-navigation/wrappers/parent-tabs-route-wrapper'
import { getRuntimeConfig } from '@eig-builder/core-utils/helpers/runtime-config-helper'

import { MANAGE } from '@eig-builder/core-utils/analytics/page-types'
import { NONE } from '@eig-builder/core-utils/analytics/flow-types'

import { ROLES } from './helpers/role-management/role-mapping'

import AccountDetailCard from './containers/account'

const Routes = [
  {
    component: withoutItemsNavigation(() => import('./containers/login')),
    pageTitle: 'Customer Support Tool - Login',
    exactly: true,
    path: '/login',
    documentTitle: 'Account Login',
    isPublic: true,
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withoutItemsNavigation(() => import('./containers/logout')),
    pageTitle: 'Customer Support Tool - Logout',
    exactly: true,
    path: '/logout',
    documentTitle: 'Account Logout',
    isPublic: true,
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./containers/role-management')),
    pageTitle: 'Customer Support Tool - Role Management',
    exactly: true,
    path: '/role-management',
    documentTitle: 'Role Management',
    requiredRole: [ROLES.ADMIN_CST, ROLES.ADMIN_MP],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./containers/sp-add-account')),
    pageTitle: 'Customer Support Tool - Create New Account',
    exactly: true,
    path: '/external-add-account',
    documentTitle: 'Create New Account',
    requiredRole: [ROLES.ADMIN_CST, ROLES.SINGLEPLATFORM, ROLES.CONSTANTCONTACT],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./containers/order-followups')),
    pageTitle: 'Customer Support Tool - Order Followups',
    documentTitle: 'Order followups',
    exactly: true,
    path: '/order-followups',
    requiredRole: [ROLES.ADMIN_CST, ROLES.SUPPORT],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: ParentTabsRouteWrapper,
    pageTitle: 'Customer Support Tool - Domains',
    documentTitle: 'Domains',
    path: '/domains',
    requiredRole: [ROLES.ADMIN_CST, ROLES.SUPPORT],
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'Renewals Report',
        path: '/domains/renewals-report',
        component: () => import('./containers/domain-renewals')
      },
      {
        title: 'Uncompleted Domain Transfers',
        path: '/domains/uncompleted-domain-transfers',
        component: () => import('./components/domains/uncompleted-domain-transfers')
      }
    ]
  },
  {
    component: withDefaultNavigation(() => import('./components/compliance/sdn/containers/detail')),
    pageTitle: 'SDN Details',
    documentTitle: 'SDN Details',
    path: '/compliance/sdn/:partnerId/:accountId',
    requiredRole: [ROLES.ADMIN_CST],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    pageTitle: 'Customer Support Tool - Compliance',
    documentTitle: 'Compliance',
    component: ParentTabsRouteWrapper,
    path: '/compliance',
    requiredRole: [ROLES.ADMIN_CST, ROLES.SUPPORT],
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'Fraud Prevention',
        path: '/compliance/fraud-prevention',
        component: () => import('./components/compliance/fraud/containers')
      },
      {
        title: 'Suspicious Activity',
        path: '/compliance/suspicious-activity',
        component: () => import('./components/compliance/flagged/containers')
      },
      {
        title: 'SDN List',
        path: '/compliance/sdn',
        component: () => import('./components/compliance/sdn/containers')
      }
    ]
  },
  {
    component: withDefaultNavigation(() => import('./containers/account-order')),
    pageTitle: 'Customer Support Tool - Billing Order Details',
    documentTitle: 'Order details',
    path: '/account-order/:partner/:id/order/:orderid',
    requiredRole: [ROLES.ADMIN_CST, ROLES.SUPPORT],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./containers/account/redirect')),
    path: '/account/:id/services',
    documentTitle: 'Account - Redirecting...',
    pageTitle: 'Account - Redirecting...',
    requiredRole: [
      ROLES.ADMIN_CST,
      ROLES.SUPPORT,
      ROLES.USER,
      ROLES.HOSTGATOR,
      ROLES.SINGLEPLATFORM,
      ROLES.CONSTANTCONTACT
    ],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./containers/account/redirect')),
    path: '/account/:id/orders',
    documentTitle: 'Account - Redirecting...',
    pageTitle: 'Account - Redirecting...',
    requiredRole: [
      ROLES.ADMIN_CST,
      ROLES.SUPPORT,
      ROLES.USER,
      ROLES.HOSTGATOR,
      ROLES.SINGLEPLATFORM,
      ROLES.CONSTANTCONTACT
    ],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./containers/account/redirect')),
    path: '/account/:id/domains',
    documentTitle: 'Account - Redirecting...',
    pageTitle: 'Account - Redirecting...',
    requiredRole: [
      ROLES.ADMIN_CST,
      ROLES.SUPPORT,
      ROLES.USER,
      ROLES.HOSTGATOR,
      ROLES.SINGLEPLATFORM,
      ROLES.CONSTANTCONTACT
    ],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./containers/account/redirect')),
    path: '/account/:id/emails',
    documentTitle: 'Account - Redirecting...',
    pageTitle: 'Account - Redirecting...',
    requiredRole: [
      ROLES.ADMIN_CST,
      ROLES.SUPPORT,
      ROLES.USER,
      ROLES.HOSTGATOR,
      ROLES.SINGLEPLATFORM,
      ROLES.CONSTANTCONTACT
    ],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: ParentTabsRouteWrapper,
    fixedComponent: AccountDetailCard,
    path: '/account/:partner/:id',
    documentTitle: 'Account Detail',
    pageTitle: 'Account',
    requiredRole: [
      ROLES.ADMIN_CST,
      ROLES.SUPPORT,
      ROLES.USER,
      ROLES.HOSTGATOR,
      ROLES.SINGLEPLATFORM,
      ROLES.CONSTANTCONTACT
    ],
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'Details',
        path: '/account/:partner/:id/sites',
        location: (params) => ['/account', params.partner, params.id, 'sites'].join('/'),
        component: () => import('./containers/account/sites-tab')
      },
      {
        title: 'Services',
        path: '/account/:partner/:id/services',
        location: (params) => ['/account', params.partner, params.id, 'services'].join('/'),
        component: () => import('./containers/account/services-tab')
      },
      {
        title: 'Orders',
        path: '/account/:partner/:id/orders',
        location: (params) => ['/account', params.partner, params.id, 'orders'].join('/'),
        component: () => import('./containers/account/orders-tab')
      },
      {
        title: 'Domains',
        path: '/account/:partner/:id/domains',
        location: (params) => ['/account', params.partner, params.id, 'domains'].join('/'),
        component: () => import('./containers/account/domains-tab')
      },
      {
        title: 'Mail',
        path: '/account/:partner/:id/mail',
        location: (params) => ['/account', params.partner, params.id, 'mail'].join('/'),
        component: () => import('./containers/account/mail-tab')
      },
      {
        title: 'Creative email',
        path: '/account/:partner/:id/creative-email',
        location: (params) => ['/account', params.partner, params.id, 'creative-email'].join('/'),
        component: () => import('./components/account/creative-email-tab')
      },
      {
        title: 'Events',
        path: '/account/:partner/:id/events',
        location: (params) => ['/account', params.partner, params.id, 'events'].join('/'),
        component: () => import('./containers/account/events-tab')
      },
      {
        title: 'Comments',
        path: '/account/:partner/:id/comments',
        location: (params) => ['/account', params.partner, params.id, 'comments'].join('/'),
        component: () => import('./containers/account/comments-tab')
      },
      {
        title: 'Billing',
        path: '/account/:partner/:id/billing',
        location: (params) => ['/account', params.partner, params.id, 'billing'].join('/'),
        component: () => import('./components/account/billing-tab')
      }
    ]
  },
  {
    component: withDefaultNavigation(() => import('./containers/account/redirect')),
    path: '/account/:id',
    documentTitle: 'Account - Redirecting...',
    pageTitle: 'Account - Redirecting...',
    requiredRole: [
      ROLES.ADMIN_CST,
      ROLES.SUPPORT,
      ROLES.USER,
      ROLES.HOSTGATOR,
      ROLES.SINGLEPLATFORM,
      ROLES.CONSTANTCONTACT
    ],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./containers/manage-dns')),
    path: '/manage-dns/:partner/:account/:id',
    documentTitle: 'Manage DNS',
    pageTitle: 'Manage DNS',
    requiredRole: [ROLES.ADMIN_CST, ROLES.SUPPORT],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./containers/comments')),
    pageTitle: 'Customer Support Tool - Comments',
    documentTitle: 'Comments',
    exactly: true,
    requiredRole: [ROLES.ADMIN_CST, ROLES.SUPPORT, ROLES.ANALYTICS],
    path: '/comments',
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withoutItemsNavigation(() => import('./components/testing-tools/test-tool-loader')),
    pageTitle: 'Testing Tools',
    documentTitle: 'Testing Tools',
    exactly: true,
    path: '/testing-tools/loading',
    requiredRole: [ROLES.USER, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withoutItemsNavigation(() => import('./components/testing-tools/create-test-account/create-test-account-loading-view')),
    pageTitle: 'Testing Tools - Create Test Account',
    documentTitle: 'Testing Tools - Create Test Account',
    exactly: true,
    path: '/testing-tools/create-account/loading',
    requiredRole: [ROLES.USER, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: ParentTabsRouteWrapper,
    pageTitle: 'Testing Tools',
    documentTitle: 'Testing Tools',
    path: '/testing-tools',
    requiredRole: [ROLES.USER, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'Create Account',
        path: '/testing-tools/create-account',
        component: () => import('./components/testing-tools/create-test-account')
      },
      {
        title: 'Url Tool',
        path: '/testing-tools/direct-brands',
        component: () => import('./components/testing-tools/url-tool')
      },
      {
        title: 'EE Test Tool',
        path: '/testing-tools/ee-hosting-brands',
        component: () => import('./containers/testing-tools/ee-test-tool')
      },
      {
        title: 'TE Test Tool',
        path: '/testing-tools/te-hosting-brands',
        component: () => import('./containers/testing-tools/te-test-tool')
      },
      {
        title: 'LogoMaker',
        path: '/testing-tools/logomaker',
        component: () => import('./components/testing-tools/logomaker')
      },
      {
        title: 'BH Builder',
        path: '/testing-tools/bhb',
        component: () => import('./components/testing-tools/bhb')
      }
    ]
  },
  {
    component: withDefaultNavigation(() => import('./components/customers')),
    pageTitle: 'Customer Support Tool - Customer Search',
    documentTitle: 'Customer Search',
    requiredRole: [
      ROLES.ADMIN_CST,
      ROLES.SUPPORT,
      ROLES.USER,
      ROLES.SINGLEPLATFORM,
      ROLES.HOSTGATOR,
      ROLES.CONSTANTCONTACT
    ],
    exactly: true,
    path: '/search',
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./components/compliance/suspicious-keywords/containers/overview')),
    pageTitle: 'Configuration - Suspicious Keywords',
    documentTitle: 'Configuration - Suspicious Keywords',
    path: '/configuration/suspicious-management',
    requiredRole: [ROLES.ADMIN_CST, ROLES.ADMIN_MP, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE
  },
  // ! IN-PRODUCT-MESSAGING
  {
    component: withDefaultNavigation(() => import('./components/in-product-messaging')),
    pageTitle: 'Customer Support Tool - In Product Messaging',
    documentTitle: 'In Product Messaging',
    exactly: true,
    path: '/in-product-messaging/list',
    requiredRole: [ROLES.ADMIN_CST, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./components/in-product-messaging/components/release-note-edit')),
    pageTitle: 'Customer Support Tool - In Product Messaging',
    documentTitle: 'In Product Messaging - Edit',
    exactly: true,
    path: '/in-product-messaging/edit/:id',
    requiredRole: [ROLES.ADMIN_CST, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./containers/in-product-messaging-form')),
    pageTitle: 'Customer Support Tool - In Product Messaging',
    documentTitle: 'In Product Messaging - Create',
    exactly: true,
    path: '/in-product-messaging/create',
    requiredRole: [ROLES.ADMIN_CST, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE
  },
  // ! END IN-PRODUCT-MESSAGING
  {
    component: ParentTabsRouteWrapper,
    pageTitle: 'Configuration - Chunks',
    documentTitle: 'Configuration - Chunks',
    path: '/configuration/miscellaneous',
    requiredRole: [ROLES.ADMIN_CST, ROLES.SUPPORT, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'Chunks',
        path: '/configuration/miscellaneous/chunks',
        component: () => import('./components/chunks')
      },
      {
        title: 'Coupon Codes',
        path: '/configuration/miscellaneous/coupon-codes',
        component: () => import('./components/coupon-codes')
      },
      {
        title: 'Welcome emails',
        path: '/configuration/miscellaneous/welcome-emails',
        component: () => import('./components/welcome-emails')
      }
    ]
  },
  {
    component: withDefaultNavigation(() => import('./components/features/feature-rules')),
    pageTitle: 'Feature Flag - Rule Datail',
    documentTitle: 'Feature Flag - Rule Datail',
    path: '/feature-flag/feature/:id',
    requiredRole: [ROLES.ADMIN_CST, ROLES.ADMIN_MP, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./components/features/feature-overview')),
    pageTitle: 'Feature Flag - Overview',
    documentTitle: 'Feature Flag - Overview',
    path: '/feature-flag/feature',
    requiredRole: [ROLES.ADMIN_CST, ROLES.ADMIN_MP, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() =>
      !['uat', 'prod'].includes(getRuntimeConfig()._env)
        ? import('./components/jarvis/components/Error')
        : import('./components/jarvis/create-account')
    ),
    pageTitle: 'Create Jarvis Account',
    documentTitle: 'Create Jarvis Account',
    path: '/jarvis/create-account',
    requiredRole: [ROLES.ADMIN_CST, ROLES.ADMIN_MP, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./containers/base-route')),
    pageTitle: 'Customer Support Tool',
    documentTitle: 'Customer Support Tool',
    path: '/',
    isPublic: true,
    pageType: MANAGE,
    flowType: NONE
  }
]

export default Routes
